import { Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Props {
  label: string;
  description?: string;
}

const FieldInfoLabel = ({ label, description }: Props) => {
  if (!description) return <>{label}</>;
  return (
    <Box
      component="span"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
    >
      {label}
      <Tooltip title={description} placement="top" arrow>
        <InfoOutlinedIcon sx={{ fontSize: 16, mt: '-2px' }} />
      </Tooltip>
    </Box>
  );
};

export default FieldInfoLabel;
